/* eslint-disable react-hooks/rules-of-hooks */
import React from 'react';
import PropTypes from 'prop-types';
import useTranslate from '~hooks/useTranslate/useTranslate';
import { getRating } from '~helpers/rating';
import styles from './one-star.module.scss';

const RATING_LABELS = {
  5: 'exellent',
  4: 'very_good',
  3: 'good',
  2: 'average',
  1: 'not_recommended',
  0: 'not_recommended',
  NoRating: 'no_score_Provided',
};

const OneStar = ({
  rating,
  numOfStars = 5,
  active = true,
  showLabel = false,
  icon = null,
  showDecimal = false,
  showRoundedRating = false,
  useText = false,
}) => {
  const fullRating = Math.min(numOfStars, Math.ceil(rating)); // rounds up to nearest integer
  const statusName = useTranslate(
    RATING_LABELS[fullRating] || RATING_LABELS.NoRating,
    RATING_LABELS[fullRating] ? RATING_LABELS[fullRating].replace('_', ' ') : 'No Score Provided'
  );

  return (
    <div className={`${styles.starRatingContainer} ${!active && styles.inactive}`}>
      {showLabel && <span>{useTranslate('rating', 'Rating:')}</span>}
      {!icon ? <span className={styles.fullStar} /> : icon}
      {useText && <span>{statusName}</span>}
      {!useText && (
        <>
          {showDecimal ? getRating(rating, showRoundedRating).toFixed(1) : fullRating}
          <span>/</span>
          <span>{numOfStars}</span>
        </>
      )}
    </div>
  );
};

OneStar.propTypes = {
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  numOfStars: PropTypes.oneOf([5, 10]),
  active: PropTypes.bool,
  showLabel: PropTypes.bool,
  icon: PropTypes.element,
  showDecimal: PropTypes.bool,
  showRoundedRating: PropTypes.bool,
  useText: PropTypes.bool,
};

export default OneStar;
